import { Breakpoints, Colors } from 'goalsetter-webapp-components';
import styled from 'styled-components';

export const QrDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  border-radius: 24px;
  background-color: ${Colors.WHITE}; /* Assuming Colors.WHITE represents the color code for white */
  padding: 32px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    flex-direction: column;
  }
`;

export const downloadButtonStyle = {
  width: '180px',
  marginTop: '24px',
};
